import axios from 'axios';

export class DiscordNotification {
  constructor() {
    this.webhookUrl = process.env.VUE_APP_DISCORD_WEBHOOK;
  }

  formatMessage(data) {
    // 處理獎品兌換通知
    if (data.type === undefined || data.prize) {
      return {
        embeds: [{
          title: "🎁 新獎品兌換通知",
          color: 0x00ff00,
          fields: [
            {
              name: "獎項資訊",
              value: `${data.prize?.name || '未知獎項'}\n市價: ${data.prize?.price || 0}元\n需要點數: ${data.prize?.points_required || 0}`,
              inline: true
            },
            {
              name: "系統回應", 
              value: `狀態: ${data.response?.status || '未知'}\n兌換編號: ${data.response?.redemption_id || '無'}`,
              inline: true
            },
            {
              name: "收件人資訊", 
              value: `姓名: ${data.shipping?.recipient_name || '未填寫'}\n電話: ${data.shipping?.phone || '未填寫'}\nEmail: ${data.shipping?.email || '未填寫'}`,
            },
            {
              name: "配送地址",
              value: `${data.shipping?.postal_code || ''} ${data.shipping?.city || ''} ${data.shipping?.district || ''} ${data.shipping?.address || '未填寫完整地址'}`
            }
          ],
          timestamp: new Date().toISOString()
        }]
      };
    }
    
    // 處理取消訂閱通知
    if (data.type === 'unsubscribe') {
      return {
        embeds: [{
          title: "❌ 用戶取消訂閱通知",
          color: 0xff0000, // 紅色
          fields: [
            {
              name: "用戶資訊",
              value: `姓名: ${data.user?.name || '未知'}\nEmail: ${data.user?.email || '未知'}\nUser ID: ${data.user?.user_id || '未知'}`,
              inline: true
            },
            {
              name: "訂閱資訊",
              value: `方案: ${data.subscription?.plan || '未知'}\n到期日: ${data.subscription?.end_date || '未知'}`,
              inline: true
            },
            {
              name: "取消原因",
              value: data.feedback?.reason || '未選擇'
            },
            {
              name: "其他意見與建議",
              value: data.feedback?.suggestion || '無'
            },
            {
              name: "刪除帳號",
              value: data.feedback?.delete_account ? '✅ 是（用戶要求刪除所有資料）' : '❌ 否'
            }
          ],
          timestamp: new Date().toISOString(),
          footer: {
            text: "小美秘書訂閱系統"
          }
        }]
      };
    }
    
    // 處理客服支援通知
    if (data.type === 'support') {
      return {
        embeds: [{
          title: "💬 客服支援請求",
          color: 0x0099ff, // 藍色
          fields: [
            {
              name: "用戶資訊",
              value: `姓名: ${data.user?.name || '未知'}\nEmail: ${data.user?.email || '未知'}\nUser ID: ${data.user?.user_id || '未知'}`,
              inline: false
            },
            {
              name: "問題與建議",
              value: data.message || '未填寫'
            }
          ],
          timestamp: new Date().toISOString(),
          footer: {
            text: "小美秘書客服系統"
          }
        }]
      };
    }
    
    // 預設格式（向後兼容）
    return {
      embeds: [{
        title: "📬 系統通知",
        color: 0x0099ff,
        description: JSON.stringify(data, null, 2),
        timestamp: new Date().toISOString()
      }]
    };
  }

  async send(data) {
    const message = this.formatMessage(data);
    try {
      await axios.post(this.webhookUrl, message);
    } catch (error) {
      console.error('Discord notification failed:', error);
    }
  }
}

export default new DiscordNotification();
